const toNumber = (value: any, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const toBooleanFlag = (value: any) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;

  const normalized = String(value ?? "").trim().toLowerCase();
  return normalized === "1" || normalized === "true" || normalized === "yes";
};

export const isPizzaOrderDetail = (detail: any = {}) =>
  !!(
    toBooleanFlag(detail?.isPizzaItem) ||
    toBooleanFlag(detail?.isPizza) ||
    toBooleanFlag(detail?.isHalfPizzaItem) ||
    detail?.pizzaSize ||
    detail?.pizzaCrust ||
    /(^|\||\*|\n)\s*(crust|size|spice)\s*:/i.test(
      String(detail?.description || detail?.note || ""),
    )
  );

export const getModifierName = (modifier: any = {}) =>
  String(
    modifier?.description ||
      modifier?.modifierName ||
      modifier?.pizzaModifierName ||
      modifier?.DtltoppName ||
      modifier?.name ||
      "",
  ).trim();

export const getModifierOptionGroupLabel = (modifier: any = {}, fallback = "Options") => {
  const directLabel = String(
    modifier?.optionName ||
      modifier?.optionGroupName ||
      modifier?.levelName ||
      modifier?.nameLevel ||
      modifier?.modifierGroupName ||
      modifier?.categoryName ||
      "",
  ).trim();

  if (directLabel) return directLabel;

  const level = toNumber(
    modifier?.level ??
      modifier?.optionLevel ??
      modifier?.DtltoppRegionid ??
      modifier?.dtltopp_regionid ??
      modifier?.regionId,
    0,
  );

  return level > 0 ? `Option ${level}` : fallback;
};

export const getModifierRegion = (modifier: any = {}) =>
  toNumber(
    modifier?.PizzaRegion ??
      modifier?.pizzaRegion ??
      modifier?.DtltoppRegionid ??
      modifier?.dtltopp_regionid ??
      modifier?.regionId,
    0,
  );

export const getModifierMultiplier = (modifier: any = {}) => {
  const explicitMultiplier = toNumber(
    modifier?.Multiplier ?? modifier?.multiplier ?? modifier?.DtltoppMultiplier,
    1,
  );
  const isMultiplier = toNumber(
    modifier?.isMultiplier ?? modifier?.IsMultiplier ?? modifier?.DtltoppIsmultiplier,
    explicitMultiplier > 1 ? 1 : 0,
  );

  if (!isMultiplier && explicitMultiplier <= 1) return 1;
  return Math.max(1, explicitMultiplier);
};

export const getModifierDisplayParts = (detail: any = {}, modifier: any = {}) => {
  const isPizzaTopping = isPizzaOrderDetail(detail);
  const region = isPizzaTopping ? getModifierRegion(modifier) : 0;
  const multiplier = isPizzaTopping ? getModifierMultiplier(modifier) : 1;

  return {
    name: getModifierName(modifier),
    sideLabel: region === 2 ? "L" : region === 3 ? "R" : region === 1 ? "W" : "",
    multiplierLabel: multiplier > 1 ? `${multiplier}x` : "",
  };
};

export const formatModifierDisplayName = (detail: any = {}, modifier: any = {}) => {
  const { name, sideLabel, multiplierLabel } = getModifierDisplayParts(detail, modifier);
  if (!name) return "";

  return [sideLabel, multiplierLabel, name].filter(Boolean).join(" ");
};
